// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__nFNYQ","search":"Settings_search__37iAK","filter":"Settings_filter___wy91"};